import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "app-cbta-error-modal-content",
	templateUrl: "./cbta-error-modal-content.component.html",
	styleUrls: ["./cbta-error-modal-content.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaErrorModalContentComponent implements OnInit {
	@Input() errorMessage!: string | string[];

	constructor() {}

	ngOnInit(): void {}

	isArray(content: any): boolean {
		return Array.isArray(content);
	}

	get errorArray(): string[] {
		const isArray = Array.isArray(this.errorMessage);

		if (isArray) {
			return this.errorMessage as string[];
		} else {
			return [];
		}
	}

	get errorString(): string {
		const isArray = Array.isArray(this.errorMessage);

		if (!isArray) {
			return this.errorMessage as string;
		} else {
			return "";
		}
	}
}
